import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { BusinesscoItem, LogisticService } from '../../../services/logistic.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-stock-control-sp-list',
  templateUrl: './stock-control-sp-list.component.html',
  styleUrls: ['./stock-control-sp-list.component.css']
})
export class StockControlSpListComponent implements OnInit {
    public setting?: Setting;

    public selectListCompanies: BusinesscoItem[] = [];

    public itemsListControls: Item[] = [];

    constructor(private datatask: DataTaskService, private logistic: LogisticService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(1700))[0];
    }

    private async loadCompanies() {
        this.selectListCompanies = await this.logistic.getCompanies();
    }

    private async loadControls() {
        if (!this.setting) return;

        this.itemsListControls = await this.datatask.Post(1701, { businessco_no: this.setting.businessco_no });
    }

    public onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'businessco_no':
                this.loadControls();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadCompanies();
        this.loadControls();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    show_setting: string;
    businessco_no: string;
}
